import { render, staticRenderFns } from "./totalHorizon.vue?vue&type=template&id=55d3676c&scoped=true&"
import script from "./totalHorizon.vue?vue&type=script&lang=js&"
export * from "./totalHorizon.vue?vue&type=script&lang=js&"
import style0 from "./totalHorizon.vue?vue&type=style&index=0&id=55d3676c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3676c",
  null
  
)

export default component.exports